import { useTranslation } from 'react-i18next'
import { useFormContext } from 'react-hook-form'
import { RevisionsList } from '../revisions'

/**
 * Revisions Tab
 *
 * Displays the revision history for the assistant with ability to:
 * - View timeline of all changes
 * - Compare any revision to current state
 * - Restore previous versions (loads into form for review before saving)
 */
export function RevisionsTab() {
  const { t } = useTranslation()
  const { getValues } = useFormContext()

  // Get the assistant ID from form values
  const assistantId = getValues('id') as number | undefined

  if (!assistantId) {
    return (
      <div className="text-center py-12 text-gray-500 dark:text-gray-400">
        {t('resources.assistants.revisions.save_first')}
      </div>
    )
  }

  return (
    <div>
      <RevisionsList resource="assistants" recordId={assistantId} />
    </div>
  )
}

export default RevisionsTab
